import { render, staticRenderFns } from "./MainLayout.vue?vue&type=template&id=171ebe49"
import script from "./MainLayout.vue?vue&type=script&lang=js"
export * from "./MainLayout.vue?vue&type=script&lang=js"
import style0 from "./MainLayout.vue?vue&type=style&index=0&id=171ebe49&scope=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\a\\1\\s\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('171ebe49')) {
      api.createRecord('171ebe49', component.options)
    } else {
      api.reload('171ebe49', component.options)
    }
    module.hot.accept("./MainLayout.vue?vue&type=template&id=171ebe49", function () {
      api.rerender('171ebe49', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/layouts/main/MainLayout.vue"
export default component.exports